const navigatorLang = () => (navigator.language.toLowerCase().includes('en') ? 'en' : 'fr');

const getLanguage = () => {
  const lang = localStorage.getItem('lang');
  return lang ?? navigatorLang();
};

export { navigatorLang };
export default getLanguage;
